import type { FpMessagePart } from "../../../../../../schemas/codegen";

/**
 * Hacky utility to try to extract the project version id from a tool call part's result
 */
export const getProjectVersionIdFromResult = (
  part: Extract<FpMessagePart, { type: "tool-call" }>,
): string | null => {
  const projectVersionId = (
    part.result as { data: { projectVersionId: unknown } } | undefined
  )?.data?.projectVersionId;

  if (typeof projectVersionId !== "string") {
    return null;
  }

  return projectVersionId;
};
